(function () {
  window.streamerEventsService = {
    get() {
      return axios.get('/api/streamer/events/get.php');
    },
    save(data) {
      return axios.post('/api/streamer/events/save.php', data);
    },
    delete(data) {
      return axios({
        method: 'delete',
        url: '/api/streamer/events/save.php',
        data: data
      });
    },
    deleteTask(data) {
      return axios({
        method: 'delete',
        url: '/api/streamer/events/save.php',
        data: data
      });
    },
    updateTaskOrder(data) {
      return axios.post('/api/streamer/events/update-task-order.php', data);
    },
    getInventory() {
      return packService.getStreamerPacks();
    }
  };
})();
